<template>
  <div class="contain">
    <router-link to="/anshu">桉树</router-link>
    <router-link to="/bbc">BCC</router-link>
    <router-link to="/xingyuan">兴源认证</router-link>
  </div>
</template>

<script>
export default {};
</script>
 
<style  lang = "scss"  scoped>
.contain {
  width: 400px;
  margin: 40px auto;
  display: flex;
  font-size: 28px;
  justify-content: space-around;
}
</style>